/**
 * Tenant-specific feature flags configuration
 *
 * This file centralizes which features are enabled for which tenants.
 * Add new features and tenants as needed.
 */

export enum TenantFeature {
  DECLARATION_PAGE = 'DECLARATION_PAGE',
}

const TENANT_FEATURE_FLAG_MAP: Record<TenantFeature, string> = {
  [TenantFeature.DECLARATION_PAGE]: 'DECLARATION_PAGE',
};

/**
 * Legacy fallback values for tenants that have not yet had an explicit
 * feature flag saved through the admin dashboard.
 */
const LEGACY_TENANT_FEATURE_MAP: Record<TenantFeature, string[]> = {
  [TenantFeature.DECLARATION_PAGE]: [
    'tnt_b490a7f051ab4cd8a6695b3c036ebcad', // Headstart Warranty Group (HWG)
    'homegauge', // Localhost Test
    'tnt_e9c70214afcc45aabc0e0103b48833a6', // HomeGauge Dev live tenant test
    'tnt_6811074066c84ddca83dc2c3b4430666', // Toco
  ],
};

/**
 * Get the persisted feature flag key for a tenant feature.
 */
export function getTenantFeatureFlagName(feature: TenantFeature): string {
  return TENANT_FEATURE_FLAG_MAP[feature];
}

/**
 * Check whether a tenant was enabled via the legacy hardcoded allowlist.
 */
export function isLegacyTenantFeatureEnabled(tenantId: string | undefined, feature: TenantFeature): boolean {
  if (!tenantId) return false;

  const enabledTenants = LEGACY_TENANT_FEATURE_MAP[feature];
  return enabledTenants.includes(tenantId);
}
